const PageTemplateType = {
    AddPhoto: 'Community/Gallery/AddPhoto',
    Addresses: 'Community/RichProfile/MyAccount/Addresses',
    AddReviewPage: 'Product/AddReviewPage',
    Affiliates: 'ThirdParty/Affiliates',
    Apply: 'CreditCard/Apply',
    BeautyInsider: 'Community/RichProfile/BeautyInsider',
    BeautyWinPromo: 'ContentStore/BeautyWinPromo',
    BrandNthCategory: 'Brands/BrandNthCategory',
    RwdBrandNthCategory: 'Brands/RwdBrandNthCategory',
    BrandsList: 'Brands/BrandsList',
    Category: 'Category/Category',
    Checkout: 'Checkout/Checkout',
    Community: 'Community/Community',
    Confirmation: 'Checkout/Confirmation',
    ContentStore: 'ContentStore/ContentStore',
    ContentStoreNoNav: 'ContentStore/ContentStoreNoNav',
    RwdContentStore: 'ContentStore/RwdContentStore',
    Departments: 'SiteMap/Departments',
    EditPlaySubscription: 'Play/EditPlaySubscription',
    EmailPostal: 'Community/RichProfile/MyAccount/EmailPostal',
    ExperienceDetails: 'OnlineReservation/ExperienceDetails',
    Gallery: 'Community/Gallery',
    Homepage: 'Homepage/Homepage',
    InstoreServices: 'Community/RichProfile/InstoreServices',
    Lists: 'Community/RichProfile/Lists',
    MyAccount: 'Community/RichProfile/MyAccount',
    MyReservations: 'OnlineReservation/MyReservations',
    NthCategory: 'Category/NthCategory',
    RwdNthCategory: 'Category/RwdNthCategory',
    OrderDetails: 'Community/RichProfile/MyAccount/OrderDetails',
    Orders: 'Community/RichProfile/MyAccount/Orders',
    PaymentMethods: 'Community/RichProfile/MyAccount/PaymentMethods',
    PlayQuiz: 'ContentStore/PlayQuiz',
    PreviewSettings: 'PreviewSettings/PreviewSettings',
    ProductPage: 'Product/ProductPage',
    UnsubscribeQuestion: 'Product/UnsubscribeQuestion',
    SubmitQuestion: 'Product/SubmitQuestion', 
    SubmitAnswer: 'Product/SubmitAnswer',
    Profile: 'Community/RichProfile/Profile',
    PurchaseHistory: 'Community/RichProfile/PurchaseHistory',
    Referrer: 'Campaigns/Referrer',
    ResetPassword: 'Community/RichProfile/MyAccount/ResetPassword',
    Search: 'Search/Search',
    ShoppingList: 'Community/RichProfile/ShoppingList',
    StoreDetail: 'Store/StoreDetail',
    StoreHub: 'OnlineReservation/StoreHub',
    Subscriptions: 'Community/RichProfile/MyAccount/Subscriptions',
    VendorGenericLogin: 'ThirdParty/VendorGenericLogin',
    VendorLogin: 'ThirdParty/VendorLogin',
    ZeroSearchResults: 'Search/ZeroSearchResults'
};

module.exports = PageTemplateType;
